export default __webpack_public_path__ + "static/media/0178d2722cd830ff5e29ce8b7236df9b1579271180811.1fbefda2.webp";